<template lang="pug">
  div.not-subscribe
    header
      img.logo(src="../assets/img/index/weijianliku.png")
      button(type="button", @click.prevnet="showLogin = true") 注册/登录
    div.content
      div.subscribe-content
        div.text
          div.case-title
            p 公关人升阶指南
            p 最经典的危机案例集锦
          div.case-function
            div.item
              div.radius
              span 记录历史案例
            div.item
              div.radius
              span 洞悉未来危机
            div.item
              div.radius
              span 打造公关知识库
          button(type="button", @click.prevnet="showLogin = true") 开始使用
        div.chart
          div#not-subscribe-chart
          div.type
            span 危机类型
            span 危机案例
    not-subsribe-footer
    login-pop(v-if="showLogin", @close="showLogin = false")
</template>
<script>
import NotSubsribeFooter from './NotSubsribeFooter'
import LoginPop from './LoginPop'
import client from '../server/server'
import echarts from 'echarts'
import _ from 'lodash'
export default {
  name: 'EventIndexNotSubScribe',
  data () {
    return {
      data: [],
      links: [],
      colors: [
        'rgb(181,144,45)',
        'rgb(185,60,66)',
        'rgb(203,141,127)',
        'rgb(195,85,59)',
        'rgb(134,181,214)',
        'rgb(49,120,186)',
        'rgb(92,128,188)',
        'rgb(78,106,189)',
        'rgb(110,74,159)',
        'rgb(34,72,135)',
        'rgb(117,179,176)',
        'rgb(36,135,135)'
      ],
      showLogin: false
    }
  },
  computed: {
  },
  mounted () {
    this.getEvents()
  },
  methods: {
    getEvents () {
      client.getPcEvents()
        .then(res => {
          if (res.code === 200) {
            let tags = _.union(res.data.map(d => d.category)).map((d, i) => {
              return {
                tag: d,
                color: this.colors[i]
              }
            })
            let types = []
            tags.forEach((d, i) => {
              types.push({
                name: d.tag,
                itemStyle: {
                  color: d.color,
                  borderWidth: 0
                },
                label: {
                  color: '#fff',
                  position: 'left',
                  fontSize: 12,
                  formatter: (d) => {
                    return `${d.name}`
                  }
                }
              })
            })
            let events = []
            res.data.forEach(d => {
              events.push({
                name: d.title,
                value: d.score,
                itemStyle: {
                  color: _.find(tags, m => m.tag === d.category).color,
                  borderWidth: 0
                },
                label: {
                  color: '#fff',
                  position: 'right',
                  fontSize: 12,
                  formatter: (d) => {
                    return d.name.length > 10 ? `${d.name.slice(0, 10)}\n${d.name.slice(10)}` : `${d.name}`
                  }
                }
              })
              this.links.push({
                source: d.category,
                target: d.title,
                value: d.score,
                lineStyle: {
                  color: _.find(tags, m => m.tag === d.category).color,
                  opacity: 0.5
                }
              })
            })
            this.data = types.concat(events)
            this.init()
          }
        })
    },
    init () {
      let chart = echarts.init(document.getElementById('not-subscribe-chart'))
      let option = {
        title: {
          text: '近期热点危机案例',
          textStyle: {
            color: '#fff'
          },
          left: '170'
        },
        series: {
          type: 'sankey',
          layout: 'none',
          top: '30',
          left: '80',
          right: '200',
          nodeWidth: 35,
          focusNodeAdjacency: 'allEdges',
          layoutIterations: 0,
          draggable: false,
          data: this.data,
          links: this.links,
          animation: false
        }
      }
      chart.setOption(option)
    }
  },
  components: {
    NotSubsribeFooter,
    LoginPop
  }
}
</script>
<style lang="scss" scoped>
.not-subscribe {
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  background: url('../assets/loginbg.png');
  color: #fff;

  .logo {
    width: 230px;
  }

  header {
    height: 60px;
    padding: 0 10%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    button {
      width: 80px;
      height: 32px;
      line-height: 32px;
      background-color: #3989cb;
      border-radius: 4px;
    }
  }

  .content {
    height: calc(100% - 240px);
    margin: 0 10%;
    background: radial-gradient(closest-corner circle at 50% 95%, rgba(255, 255, 255, 0.2), rgba(0, 0, 0, 0));

    .subscribe-content {
      margin-top: 70px;
      height: calc(100% - 160px);
      display: flex;

      .text {
        flex: 1;

        .case-title {
          margin-top: 100px;
          font-size: 56px;
          font-family: MicrosoftYaHei;
        }

        .case-function {
          margin-top: 70px;

          .item {
            display: flex;
            align-items: center;
            margin-bottom: 30px;

            .radius {
              width: 10px;
              height: 10px;
              background-image: linear-gradient(270deg,
                  #2a3e63 0%,
                  #3989cb 100%);
              border-radius: 5px;
              margin-right: 18px;
            }
          }
        }

        button {
          width: 108px;
          height: 46px;
          line-height: 46px;
          background-color: #3989cb;
          border-radius: 4px;
        }
      }

      .chart {
        width: 620px;
        position: relative;

        #not-subscribe-chart {
          width: 100%;
          height: 100%;
        }

        .type {
          width: 100%;
          position: absolute;
          bottom: 0;
          padding: 0 200px 0 80px;
          display: flex;
          justify-content: space-between;
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/NotSubscribe.vue